module["exports"] = [
  "México"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/default_country.js
// module id = 558
// module chunks = 0